module.exports = __webpack_public_path__ + "static/Muli-BoldItalic.648f5a7e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/muli/Muli-BoldItalic.ttf
// module id = 331
// module chunks = 114276838955818